<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="pl-0">
      <v-list-item>
        <v-list-item-avatar>
          <v-icon :color="isActiveStep ? 'primary' : 'grey'">
            {{ icon }}
          </v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <span>
              {{ title }}
            </span>
          </v-list-item-title>

          <v-list-item-subtitle>
            <span>
              {{ subtitle }}
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <v-card flat>
        <v-card-text>
          <slot name="content" />
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-if="hasPreviousSubStep"
            text
            @click="goToPreviousStep"
          >
            Back
          </v-btn>

          <v-spacer />

          <v-btn
            text
            @click="goToNextStep(!hasNextSubStep)"
          >
            <span v-if="hasNextSubStep">
              Continue
            </span>
            <span v-else>
              Next
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import ModelableMixin from '../../mixins/modelable';

export default {
  name: 'OrderStep',

  mixins: [
    ModelableMixin,
  ],

  props: {
    icon: String,

    title: String,

    subtitle: String,

    isActiveStep: Boolean,

    hasNextSubStep: Boolean,

    hasPreviousSubStep: Boolean,
  },

  methods: {
    goToNextStep(isLastSubStep) {
      if (isLastSubStep) {
        this.localValue.currentStep.subStep = 0;
        this.localValue.currentStep.step++;
      } else {
        this.localValue.currentStep.subStep++;
      }
    },

    goToPreviousStep() {
      this.localValue.currentStep.subStep--;
    },
  },
};
</script>

<style scoped>

</style>
